module.exports = __webpack_public_path__ + "static/media/shape3_2.7467aa52.obj";